<template>
  <div class="order-status-card" v-if="isShowStatusCard == 1">
    <div class="status-title" v-if="orderBranchInfo.title">
      {{ orderBranchInfo.title
      }}<img
        class="status-icon finger-style"
        v-if="$useOptionChain(orderBranchInfo, 'ruleNotice.icon')"
        :src="$useOptionChain(orderBranchInfo, 'ruleNotice.icon')"
        alt=""
        @click="goIconUrl"
      />
    </div>
    <div class="status-content" v-if="orderBranchInfo.content">
      {{ orderBranchInfo.content }}
    </div>
    <div
      class="status-btn ellipsis finger-style"
      @click="clickBtn"
      v-if="orderBranchInfo.btn"
    >
      {{ orderBranchInfo.btn }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { NewAlert } from '@didi/r-fusion-pc';
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage';
Vue.prototype.$rconfirm = NewAlert.confirm;
import i18n from '@/i18n/locale';

export default {
  name: 'OrderStatusCard',
  props: {
    orderBranchInfo: Object,
    orderId: String,
    status: Number,
  },
  data() {
    return {
      isShowStatusCard: 2, //1：显示 2：隐藏，
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.orderBranchInfo?.type == 1) {
        this.isShowStatusCard = 1;
        setLocalStorage('isShowStatusCard', this.isShowStatusCard);
      } else {
        this.isShowStatusCard = getLocalStorage('isShowStatusCard') || 1;
      }
      this.$trackEvent({
        eventId: 'sailing_c_x_orderpage_branch_state_sw',
        eventLabel: '订单分支状态通知组件曝光',
        attrs: {
          order_id: this.orderId,
          order_status: this.status,
        },
      });
    });
  },
  methods: {
    clickBtn() {
      this.$trackEvent({
        eventId: 'sailing_c_x_orderpage_branch_state_ck',
        eventLabel: '订单分支状态通知组件按钮点击',
        attrs: {
          order_id: this.orderId,
          order_status: this.status,
        },
      });
      if (this.orderBranchInfo?.type === 1) {
        // 展示弹窗
        this.$rconfirm(i18n.t('您收到了订单了吗？'), '', {
          confirmButtonText: i18n.t('确认'),
          cancelButtonText: i18n.t('取消'),
          customClass:'el-message-box_d-reset',
          showCancelButton: true,
          showClose: false,
          center: true,
          callback: async action => {
            if (action === 'confirm') {
              this.$emit('confrimCard');
            }
          },
        });
      } else if (this.orderBranchInfo?.type === 0) {
        // 点击的时候隐藏当前卡片
        this.isShowStatusCard = 2;
        setLocalStorage('isShowStatusCard', this.isShowStatusCard);
      }
    },
    goIconUrl() {
      const url = this.orderBranchInfo?.ruleNotice?.url;
      this.$emit('goIconUrl', { url });
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
